import { GET_CALL_PER_DAY, GET_CATEGORY_SUMMARY, GET_ENGAGEMENTS, GET_RECENT_CALL_DETAILS, GET_RECENT_CALLS } from "../Types/types";


const initialState = {
  resultSummary: null,
  graphData:null,
  recentCalls: [],
  recentCallDetails: null,
  engagement : [],
};

const interviewResultsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CATEGORY_SUMMARY:
        return { ...state, resultSummary: action.payload };
    case GET_CALL_PER_DAY :
        return { ...state, graphData: action.payload };
    case GET_RECENT_CALLS :
        return { ...state, recentCalls: action.payload };
    case GET_RECENT_CALL_DETAILS :
      return { ...state, recentCallDetails: action.payload };
    case GET_ENGAGEMENTS :
      return { ...state, engagement: action.payload };
    default:
      return state;
  }
}

export default interviewResultsReducer;